/**
 * This file is auto-generated by scripts/generate-available-languages.js
 * DO NOT EDIT MANUALLY
 *
 * To add a new language, simply add a {language-code}.json file to:
 * assets/i18n/
 *
 * Note: en-XA (pseudolocalization) is generated from en-US.json
 */

// Available languages for the application
export const AVAILABLE_LANGUAGES: string[] = [
  "en-US",
  "en-XA"
];

export type AvailableLanguage = typeof AVAILABLE_LANGUAGES[number];
